// @ts-check
import { useState, useEffect } from 'react';

/**
 * Deferred value (not in React 17, but in React 18)
 * @template Type
 * @param {Type} value The value to defer
 * @param {number} [delay=200] Delay in ms
 * @returns {Type}
 */
const useDeferredValue = (value, delay = 200) => {
  const [deferredValue, setDeferredValue] = useState(value);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDeferredValue(value);
      setIsReady(true);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [value, delay]);

  return isReady ? deferredValue : value;
};

export default useDeferredValue;
